//import Hotjar from "@hotjar/browser";
import * as Sentry from "@sentry/react";
import { callGtag } from "../../services/ga";
import { queueEvent } from "./analyticsBatcher";

export const GA_TRACKING_ID = "G-893ZGSLH00";
export const GA_DEBUG_MODE = false;

type AssetType = "catalogs" | "products" | "space" | "users";

export type EventRecord = {
  type?: "feature" | "conversion" | "journey" | "session" | "error" | "trace";
  category: string;
  action: string;
  value?: number;
  label?: string;
  ts?: string;
  feature?: boolean;
  internal?: boolean;
  tag?: boolean;
  timestamp?: string;
  sessionId?: string;
  assets?: AssetType[];
  metadata?: Record<string, unknown>;
  flush?: boolean;
  intercomEvent?: string;
};

/**
 * The only `action category` names forwarded to Intercom, besides an explicit `intercomEvent`.
 * The workspace holds 120 event names and every unlisted feature action used to claim one: it sat
 * full for a year, so `catalog-published` was dropped until slots were freed (2026-10-09).
 * Add a name here only when an Intercom message, series or segment will trigger on it.
 */
const INTERCOM_EVENTS = new Set([
  "add product",
  "upload product",
  "create catalog",
  "publish catalog",
  "pdf catalog",
  "create showroom",
]);

export const trackEvent = (event: EventRecord) => {
  if (!event.internal) {
    callGtag("event", event.category + "_" + event.action, {
      value: event.value ?? 1,
      debug_mode: GA_DEBUG_MODE,
    });
    Sentry.addBreadcrumb({
      category: event.category + "_" + event.action,
      message: `${event.value > 1 ? "[" + event.value + "] " : ""}${
        event.label
      }`,
      level: "info",
    });
  }
  if (event.tag || event.feature) {
    Sentry.setTag("feature." + event.category, event.action);
  }
  const intercomName =
    event.intercomEvent || event.action + " " + event.category;
  if (
    event.feature &&
    (event.intercomEvent || INTERCOM_EVENTS.has(intercomName))
  ) {
    Intercom("trackEvent", intercomName, {
      label: event.label,
      value: event.value ?? 1,
    });
  }
  queueEvent(event);
};
